module.exports = __webpack_public_path__ + "static/media/hairdresser.9554a8f8.jpg";